import "./LoaderExcel.css";

const LoaderExcel = () => {
    return (
        <div className="boxloader3-lealtad">
            <div className="loader3-lealtad">
                Creando
                <span></span>
            </div>
        </div>
    );
};

export default LoaderExcel;